module.exports = __webpack_public_path__ + "static/media/Joseph Ojebola.9f5f484d.jpg";